import React from 'react'
import styled from 'styled-components'
import autoSrc from '../../../../assets/autotoma.png'
import propTypes, { any, bool } from 'prop-types'

const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${props => !props.$selected ? ' #f2f4f6' : 'var(--first)'};
  padding: 1em;
  height: ${props => props.$height}px;
  box-sizing: border-box;
  @media screen and (max-width:600px) {
    padding: 1em 1.5em;
  }
`

const Img = styled.img`
  display: block;
  max-width: 33%;
  @media screen and (max-width:1400px) {
    max-width: 30%;
  }
  @media screen and (max-width:600px) {
    max-width: 25%;
  }
`
const Message = styled.div`
  text-align: center;
  margin-top: .5em;
  font-size: 2.3em;
  font-family: 'imlbold'; font-weight: bold;
  color: ${props => props.$selected ? 'var(--second)' : '#999999'};
  line-height: 1em;
  @media screen and (max-width:600px) {
    font-size: 1.8em;
  }
`
const Card = props => {
  return (
    <Content $selected={props.selected} $height={props.height || ''} id={props.id || ''}>
      <Img src={props.image || autoSrc} />
      <Message $selected={props.selected}>
        {props.message || 'Módulo de Atención Externa'}
      </Message>
    </Content>
  )
}

Card.propTypes = {
  message: propTypes.string,
  image: propTypes.string,
  selected: bool,
  height: propTypes.number,
  id: any
}

export default Card
